import { render, staticRenderFns } from "./KeywordDatabase.vue?vue&type=template&id=88370752&"
import script from "./KeywordDatabase.vue?vue&type=script&lang=js&"
export * from "./KeywordDatabase.vue?vue&type=script&lang=js&"
import style0 from "./KeywordDatabase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports